import { computed, Directive, Signal, viewChildren } from '@angular/core';
import { ProductComponentBase } from './ProductComponentBase';

@Directive()
export class ProductSectionComponentBase extends ProductComponentBase {
  private readonly _content = viewChildren<{ loading: Signal<boolean>; hasContent: Signal<boolean> }>('content');
  protected override readonly computeIsLoading = () => computed(() => this._content().some((c) => c.loading()));
  protected override readonly computeHasContent = () => computed(() => this._content().some((c) => c.hasContent()));
}
